import React, { useState } from "react";
import { closeforgotPasswordModal } from "../../features/slices/ModalSlice";
import { useDispatch } from "react-redux";
import ForgotPasswordActions, {
  FORGOT_PASSWORD_STEPS,
} from "./ForgotPasswordActions";
export default function ForgotPasswordModal() {
  const dispatch = useDispatch();
  const [step, setStep] = useState(FORGOT_PASSWORD_STEPS.phone);
  const isOtpStep = step === FORGOT_PASSWORD_STEPS.otp;

  const hideForgotPasswordModal = () => {
    dispatch(closeforgotPasswordModal());
  };
  const closeModal = (event) => {
    if (event.target.id === "fadeModal") dispatch(closeforgotPasswordModal());
  };

  return (
    <div
      className={`modal fade show${isOtpStep ? " otp--modal" : ""}`}
      style={{
        display: "block",
        backdropFilter: "blur(15px)",
        background: "rgb(70, 70, 70, 0.6)",
      }}
      id="fadeModal"
      tabIndex="-1"
      onClick={closeModal}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="modal-title fs-5">
              {isOtpStep ? "Mobile Verification" : "Forgot Password"}
            </h2>
            <i
              data-bs-dismiss="modal"
              aria-label="Close"
              className="bi bi-x-lg"
              onClick={hideForgotPasswordModal}
            ></i>
          </div>
          <div
            className={`modal-body ${
              isOtpStep ? "mobile-otp-modal--body text-center" : "login-form"
            }`}
          >
            <ForgotPasswordActions onStepChange={setStep} />
          </div>
        </div>
      </div>
    </div>
  );
}
